module.exports = __webpack_public_path__ + "img/1594892373.3ca95abf.png";